import React from 'react';
import { Icon, Collapse, Card, Avatar, Divider, Row, Col, Layout } from 'antd';

const gridStyle = {
  width: '25%',
  minWidth: '324px',
  float: 'none',
};

const TabContentHeader = ({ loading, title, color, icon, actions, children }) => (
  <div
    style={{
      boxShadow: '0 2px 2px -2px #e0e0e0',
      zIndex: '1',
      background: '#fff',
      padding: '0 32px',
      position: 'sticky',
      top: '40px',
    }}
  >
    <Row type="flex" style={{ lineHeight: '80px', height: '80px' }} align="middle" justify="space-between">
      <Col style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
        <Avatar
          shape="square"
          icon={icon}
          style={{
            verticalAlign: 'middle',
            background: color || 'none',
            color: color ? '#fff' : 'rgba(0, 0, 0, 0.65)',
            marginRight: '8px',
          }}
        />
        <h3
          style={{
            marginBottom: '0',
            display: 'inline-block',
            maxWidth: '300px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={title}
        >
          {title}
        </h3>
        {loading && <Icon type="loading" />}
      </Col>
      <Col>
        {actions}
      </Col>
    </Row>
    {children &&
      <Card bordered={false} bodyStyle={{ padding: 0, position: 'relative', display: 'flex', alignItems: 'stretch' }}>
        {[...children].map((child, i) => (
          <Card.Grid key={i} style={gridStyle}>
            {child}
          </Card.Grid>
        ))}
      </Card>
    }
  </div>
);

export default TabContentHeader;
